// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoReportModal-cls1_Obx","cls2":"VideoReportModal-cls2_9PH VideoReportModal-cls1_Obx"};